import { useMutation, useQueryClient } from '@tanstack/react-query'

import { QUERY_KEYS } from '../../../lib/queryKeys'
import { approvePackageReq } from '../packageReqService'

export const useApprovePackageRequest = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: data => approvePackageReq(data),
    onSuccess: () => {
      // Invalidate and refetch package requests
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.PACKAGE_REQUESTS] })
    },
  })
}
